import { render, staticRenderFns } from "./DocumentosLeilao.vue?vue&type=template&id=ab2d3874&"
import script from "./DocumentosLeilao.vue?vue&type=script&lang=js&"
export * from "./DocumentosLeilao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports